export default __webpack_public_path__ + "static/media/dairy-and-cheese-alternatives-vegshelf.cc0a3a19.png";